(function () {
  'use strict';

  var STORAGE_KEY = 'bsInquirySent';
  var DEFAULT_PHONE_PREFIX = '+91 ';
  var LOCK_MESSAGE = "You've already sent us an enquiry. Someone from our team will call you back shortly.";

  function safeGet(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function safeSet(key, value) {
    try { sessionStorage.setItem(key, value); } catch (e) {}
  }

  function hasAlreadySent() {
    return safeGet(STORAGE_KEY) === '1';
  }
  function markAsSent() {
    safeSet(STORAGE_KEY, '1');
  }

  try {
    if (new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
      markAsSent();
    }
  } catch (e) {}

  function isInquiryForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    return /\/contact(\b|#|\?|$)/i.test(action);
  }

  // Makes the "+91 " prefix permanent and non-editable on a phone field --
  // the user can only type/edit the digits that follow it. Handles typing,
  // backspace/delete at or before the prefix boundary, select-all-and-type,
  // and pasting a number that already includes a leading 91 country code.
  function lockPhonePrefix(input) {
    if (input.dataset.bsPhoneLocked === '1') return;
    input.dataset.bsPhoneLocked = '1';

    function ensurePrefix() {
      var raw = input.value;
      if (raw.indexOf(DEFAULT_PHONE_PREFIX) === 0) return;
      var digits = raw.replace(/[^\d]/g, '');
      if (digits.slice(0, 2) === '91' && digits.length > 10) {
        digits = digits.slice(2);
      }
      input.value = DEFAULT_PHONE_PREFIX + digits;
    }

    ensurePrefix();

    input.addEventListener('focus', function () {
      ensurePrefix();
      if (input.selectionStart < DEFAULT_PHONE_PREFIX.length) {
        input.setSelectionRange(input.value.length, input.value.length);
      }
    });
    input.addEventListener('click', function () {
      if (input.selectionStart < DEFAULT_PHONE_PREFIX.length) {
        input.setSelectionRange(input.value.length, input.value.length);
      }
    });
    input.addEventListener('keydown', function (e) {
      var start = input.selectionStart;
      var end = input.selectionEnd;
      if (
        (e.key === 'Backspace' || e.key === 'Delete') &&
        start <= DEFAULT_PHONE_PREFIX.length &&
        end <= DEFAULT_PHONE_PREFIX.length
      ) {
        e.preventDefault();
      }
    });
    input.addEventListener('input', ensurePrefix);
  }

  function prefillPhoneFields(scope) {
    var root = scope || document;
    if (!root.querySelectorAll) return;
    var fields = root.querySelectorAll('input[type="tel"]');
    fields.forEach(function (input) {
      var form = input.closest('form');
      if (!isInquiryForm(form)) return;
      lockPhonePrefix(input);
    });
  }

  function injectToastStyles() {
    if (document.getElementById('bs-inquiry-toast-style')) return;
    var style = document.createElement('style');
    style.id = 'bs-inquiry-toast-style';
    style.textContent =
      '#bs-inquiry-toast{position:fixed;left:50%;top:18px;transform:translateX(-50%) translateY(-8px);z-index:2147483000;max-width:min(90vw,420px);padding:14px 20px;border-radius:12px;background:#082A55;color:#fff;font:600 14px/1.45 "Lato",Arial,sans-serif;box-shadow:0 16px 40px rgba(8,42,85,.35);text-align:center;opacity:0;transition:opacity .25s ease,transform .25s ease}' +
      '#bs-inquiry-toast.is-visible{opacity:1;transform:translateX(-50%) translateY(0)}';
    document.head.appendChild(style);
  }

  function showLockedToast() {
    injectToastStyles();
    var existing = document.getElementById('bs-inquiry-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'bs-inquiry-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = LOCK_MESSAGE;
    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 300);
    }, 5000);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isInquiryForm(form)) return;
    if (hasAlreadySent()) {
      event.preventDefault();
      event.stopPropagation();
      showLockedToast();
    }
  }, true);

  function init(scope) {
    prefillPhoneFields(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
